export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      gallery: "Proyectos",
      about: "Nosotros",
      contact: "Contacto",
      cta: "Presupuesto gratis",
    },
    hero: {
      eyebrow: "32 años construyendo confianza en Alicante",
      title_l1: "Reformas con",
      title_highlight: "acabado impecable.",
      title_l2: "Sin sorpresas.",
      subtitle:
        "Reformas integrales, baños, pintura, placas solares y aire acondicionado. Materiales de primera calidad y 2 años de garantía en todos nuestros trabajos.",
      cta_primary: "Solicitar presupuesto gratis",
      cta_secondary: "Hablar por WhatsApp",
      scroll: "Descubrir",
    },
    trust: {
      years_num: "32",
      years_label: "Años de experiencia",
      warranty_num: "2",
      warranty_label: "Años de garantía",
      area_num: "100%",
      area_label: "Provincia de Alicante",
      materials_num: "A+",
      materials_label: "Materiales de primera",
    },
    ticker: [
      "Reformas integrales",
      "Baños de diseño",
      "Placas solares",
      "Aire acondicionado",
      "Pintura profesional",
      "Obra de cero al acabado",
      "Calidad certificada",
      "2 años de garantía",
    ],
    services: {
      eyebrow: "Nuestros servicios",
      title: "Todo lo que tu obra necesita, bajo un mismo techo.",
      subtitle:
        "De la demolición al último detalle. Gestionamos cada fase con un equipo propio con décadas de experiencia.",
      items: {
        renovation: {
          tag: "01",
          name: "Reformas integrales",
          desc: "Del cero al acabado: albañilería, fontanería, electricidad, carpintería y decoración. Gestión completa y llave en mano.",
          features: ["Proyecto llave en mano", "Gestión de permisos", "Equipo propio certificado"],
        },
        bathroom: {
          tag: "02",
          name: "Reformas de baños",
          desc: "Baños con diseño moderno y materiales premium. Platos de ducha de obra, nichos iluminados, sanitarios suspendidos.",
          features: ["Diseño 3D incluido", "Materiales Porcelanosa", "Ejecución rápida y limpia"],
        },
        solar_ac: {
          tag: "03",
          name: "Placas solares y aire acondicionado",
          desc: "Instalación y mantenimiento de sistemas fotovoltaicos y climatización. Ahorra en tu factura desde el primer día.",
          features: ["Instalación certificada", "Mantenimiento anual", "Marcas líderes"],
        },
        painting: {
          tag: "04",
          name: "Pintura general",
          desc: "Pintura interior y exterior, gotelé, estucos, esmaltes y tratamientos anti-humedad. Acabado profesional y duradero.",
          features: ["Protección de muebles", "Pinturas ecológicas", "Limpieza total incluida"],
        },
        ceramica: {
          tag: "05",
          name: "Cerámica y alicatados",
          desc: "Colocación de cerámica, porcelánico, gres y mosaicos. Suelos, paredes, terrazas y piscinas con corte preciso y juntas perfectas.",
          features: ["Corte y bisel a medida", "Suelos y paredes", "Garantía 2 años"],
        },
      },
      learn_more: "Pedir presupuesto",
    },
    gallery: {
      eyebrow: "Proyectos reales",
      title: "Nuestro trabajo habla por sí solo.",
      subtitle: "Obras ejecutadas por nuestro equipo en Alicante. Calidad en cada detalle.",
      cta: "Quiero un proyecto así",
      tabs: {
        all: "Todos",
        renovation: "Reformas",
        bathroom: "Baños",
        solar_ac: "Solar & AC",
        painting: "Pintura",
        ceramica: "Cerámica",
      },
      empty: "Aún no hay fotos en esta categoría.",
    },
    about: {
      eyebrow: "Sobre nosotros",
      title: "Tres décadas construyendo hogares en la Costa Blanca.",
      p1: "Modolo Multiservices nació para ofrecer algo que no siempre es fácil de encontrar: una obra que termina en el plazo acordado, con el presupuesto pactado y con un acabado del que estar orgulloso.",
      p2: "Trabajamos con equipo propio, materiales de primera calidad y proveedores de confianza. Cada reforma incluye 2 años de garantía y un seguimiento post-obra porque nuestra reputación se construye trabajo a trabajo.",
      points: [
        "Equipo propio multidisciplinar",
        "Materiales certificados",
        "Cumplimiento de plazos",
        "2 años de garantía escrita",
      ],
      cta: "Conócenos en persona",
    },
    contact: {
      eyebrow: "Presupuesto sin compromiso",
      title: "Cuéntanos tu proyecto.",
      subtitle: "Te respondemos en menos de 24 horas con una propuesta clara y detallada.",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Email (opcional)",
      service: "Servicio que necesitas",
      message: "Cuéntanos los detalles",
      photos_label: "Añade fotos del proyecto (opcional)",
      photos_hint: "Máx. 5 imágenes · hasta 5 MB cada una",
      photos_add: "Seleccionar fotos",
      photos_remove: "Quitar",
      photos_too_many: "Máximo 5 fotos por solicitud",
      photos_too_big: "Alguna foto supera los 5 MB",
      photos_invalid: "Solo se aceptan imágenes",
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success: "¡Solicitud recibida! Te llamamos en breve.",
      error: "No se pudo enviar. Intenta por WhatsApp, por favor.",
      or: "o escríbenos directamente por",
      whatsapp: "WhatsApp",
      services_options: {
        renovation: "Reforma integral",
        bathroom: "Reforma de baño",
        solar: "Placas solares",
        ac: "Aire acondicionado",
        painting: "Pintura",
        ceramica: "Cerámica / alicatado",
        other: "Otro / No estoy seguro",
      },
      info: {
        address_label: "Oficina",
        address_value: "Calle Unión Europea, 10, Planta 3B\nLos Montesinos, Alicante",
        phone_label: "Teléfono / WhatsApp",
        email_label: "Email",
        hours_label: "Horario",
        hours_value: "Lun - Vie · 08:00 – 18:00",
      },
    },
    footer: {
      tagline: "Reformas profesionales en toda la provincia de Alicante desde hace 32 años.",
      rights: "Todos los derechos reservados.",
      cif: "CIF:",
      links_title: "Navegación",
      services_title: "Servicios",
      contact_title: "Contacto",
      map: "Ver en Google Maps",
      made: "Diseñado para los clientes de Modolo Multiservices",
    },
    floating: {
      wa_label: "Chatear por WhatsApp",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Projects",
      about: "About",
      contact: "Contact",
      cta: "Free quote",
    },
    hero: {
      eyebrow: "32 years building trust in Alicante",
      title_l1: "Renovations with",
      title_highlight: "flawless finish.",
      title_l2: "No surprises.",
      subtitle:
        "Full renovations, bathrooms, painting, solar panels and air conditioning. Top-quality materials and a 2-year warranty on every job.",
      cta_primary: "Get a free quote",
      cta_secondary: "Message us on WhatsApp",
      scroll: "Explore",
    },
    trust: {
      years_num: "32",
      years_label: "Years of experience",
      warranty_num: "2",
      warranty_label: "Year warranty",
      area_num: "100%",
      area_label: "Alicante province",
      materials_num: "A+",
      materials_label: "Premium materials",
    },
    ticker: [
      "Full renovations",
      "Designer bathrooms",
      "Solar panels",
      "Air conditioning",
      "Professional painting",
      "Turn-key projects",
      "Certified quality",
      "2-year warranty",
    ],
    services: {
      eyebrow: "Our services",
      title: "Everything your home needs, under one roof.",
      subtitle:
        "From demolition to the last detail. Our in-house team handles every phase with decades of expertise.",
      items: {
        renovation: {
          tag: "01",
          name: "Full renovations",
          desc: "From zero to finish: masonry, plumbing, electrical, carpentry and interior work. Complete turn-key project management.",
          features: ["Turn-key delivery", "Permit handling", "In-house certified crew"],
        },
        bathroom: {
          tag: "02",
          name: "Bathroom reforms",
          desc: "Modern bathrooms with premium materials. Custom shower trays, illuminated niches, wall-hung sanitaryware.",
          features: ["3D design included", "Porcelanosa materials", "Fast and clean execution"],
        },
        solar_ac: {
          tag: "03",
          name: "Solar panels & air conditioning",
          desc: "Installation and maintenance of photovoltaic and HVAC systems. Start saving on your bills from day one.",
          features: ["Certified installation", "Annual maintenance", "Leading brands"],
        },
        painting: {
          tag: "04",
          name: "Painting services",
          desc: "Interior and exterior painting, stucco, enamels and anti-damp treatments. Professional, long-lasting finish.",
          features: ["Furniture protection", "Eco-friendly paints", "Full clean-up included"],
        },
        ceramica: {
          tag: "05",
          name: "Tiling & ceramics",
          desc: "Ceramic, porcelain, stoneware and mosaic installation. Floors, walls, terraces and pools with precise cuts and perfect grouting.",
          features: ["Custom cuts & bevels", "Floors and walls", "2-year warranty"],
        },
      },
      learn_more: "Request a quote",
    },
    gallery: {
      eyebrow: "Real projects",
      title: "Our work speaks for itself.",
      subtitle: "Jobs executed by our own crew across Alicante. Quality in every detail.",
      cta: "I want a project like this",
      tabs: {
        all: "All",
        renovation: "Renovations",
        bathroom: "Bathrooms",
        solar_ac: "Solar & AC",
        painting: "Painting",
        ceramica: "Tiling",
      },
      empty: "No photos in this category yet.",
    },
    about: {
      eyebrow: "About us",
      title: "Three decades building homes on the Costa Blanca.",
      p1: "Modolo Multiservices was founded to deliver what is not always easy to find: a renovation that ends on time, on budget, and with a finish you can be proud of.",
      p2: "We work with our own crew, premium materials and trusted suppliers. Every project comes with a 2-year warranty and post-works follow-up because our reputation is built job by job.",
      points: [
        "In-house multidisciplinary team",
        "Certified materials",
        "On-time delivery",
        "2-year written warranty",
      ],
      cta: "Meet us in person",
    },
    contact: {
      eyebrow: "Free, no-obligation quote",
      title: "Tell us about your project.",
      subtitle: "We reply within 24 hours with a clear, detailed proposal.",
      name: "Full name",
      phone: "Phone",
      email: "Email (optional)",
      service: "Service you need",
      message: "Tell us the details",
      photos_label: "Attach project photos (optional)",
      photos_hint: "Max 5 images · up to 5 MB each",
      photos_add: "Select photos",
      photos_remove: "Remove",
      photos_too_many: "Maximum 5 photos per request",
      photos_too_big: "One of the photos exceeds 5 MB",
      photos_invalid: "Only images are accepted",
      submit: "Send request",
      sending: "Sending...",
      success: "Request received! We will call you shortly.",
      error: "Could not send. Please try WhatsApp.",
      or: "or write to us directly on",
      whatsapp: "WhatsApp",
      services_options: {
        renovation: "Full renovation",
        bathroom: "Bathroom reform",
        solar: "Solar panels",
        ac: "Air conditioning",
        painting: "Painting",
        ceramica: "Tiling / ceramics",
        other: "Other / Not sure yet",
      },
      info: {
        address_label: "Office",
        address_value: "Calle Unión Europea, 10, Floor 3B\nLos Montesinos, Alicante",
        phone_label: "Phone / WhatsApp",
        email_label: "Email",
        hours_label: "Hours",
        hours_value: "Mon - Fri · 8:00 – 18:00",
      },
    },
    footer: {
      tagline: "Professional renovations across the province of Alicante for the past 32 years.",
      rights: "All rights reserved.",
      cif: "CIF:",
      links_title: "Navigation",
      services_title: "Services",
      contact_title: "Contact",
      map: "Open in Google Maps",
      made: "Crafted for Modolo Multiservices' clients",
    },
    floating: {
      wa_label: "Chat on WhatsApp",
    },
  },
};
